"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconNewsletter = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconNewsletter = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 15c-.399 0-.75-.141-1.5-.504L0 9v10.5c0 .825.675 1.5 1.5 1.5h21c.825 0 1.5-.675 1.5-1.5V9l-10.5 5.496c-.75.363-1.101.504-1.5.504zM22.5 3h-21C.675 3 0 3.675 0 4.5v1.137l12 6.308 12-6.308V4.5c0-.825-.675-1.5-1.5-1.5z"
}));
exports.IconNewsletter = IconNewsletter;
//# sourceMappingURL=IconNewsletter.js.map